<template>
  <div>
    <div class='p-znlNew' v-show='type === "new" '>
      <modules-View
        :type='type'
        ref='modulesView'
        :configId='id'
        :token='token'>
      </modules-View>
    </div>
    <page-layout
      class='p-ZnlAdo'
      :title='portname'
      v-loading.fullscreen='pageloading'
      v-show='type === "old" '
      element-loading-text='报告生成中...'>
      <div slot='title' class='p-ZnlAdo-tip'>
        <div v-for='(item, index) in adoConfig.Description' :key='index'>
          {{ item }}
        </div>
      </div>
      <div class='p-ZnlAdo-report clearfix'>
      <span
        class='p-ZnlAdo-report-input pull-left'
        v-for='item in adoConfig.Params'
        :key='item.ID'>
        <span class='p-ZnlAdo-report-input-title'>
          {{ item.Description }}:
        </span>
        <znl-input
          :border='true'
          :height='26'
          :width='170'
          v-model='reportParameter[item.Name]'
          :form-type="item.Type === 0 ? 'input' : item.Type === 2 ? 'datepicker' : 'input'">
        </znl-input>
      </span>
      </div>
      <div class='p-ZnlAdo-report'>
        <el-upload
          class='upload-data'
          v-if='adoConfig.ParamTypeName'
          :action='`${proconfig}report/upload/file`'
          :file-list='fileList'
          :on-success='onSuccess'
          :show-file-list='false'
          :headers='headers'>
          <znl-button type='text'> 上传文件</znl-button>
        </el-upload>
        <span v-if='adoConfig.ParamTypeName'>
        (
        <a
          target='_blank'
          class='znl-ZnlAdo-upload-a'
          :href='`${proconfig}report/download/template/${id}`'
          download
        >下载模板</a
        >
        )
      </span>
      </div>
      <znl-button
        :width='100'
        :height='30'
        style-type='main'
        v-if='
        (adoConfig.Params && adoConfig.Params.length > 0) ||
        adoConfig.Price !== 0'
        @click='() => ispurchased()'>
        生成报告
      </znl-button>
      <pane>
        <div slot='title' class='p-ZnlAdo-report-title'>
          <a
            target='_blank'
            :href='`${proconfig}report/download/${DownloadFileName}`'
            download
            class='znl-ZnlAdo-upload znl-ZnlAdo-upload-a'
            :style='uploadStyle'
            v-if='
            DownloadFileName &&
            adoConfig.Downloadable &&
            chartsOptions.Datas.length > 0'>
            下载报告
          </a>
        </div>
        <znl-echarts
          ref='znlEcharts'
          :portname='portname'
          :charts-options='chartsOptions'
          :display-table='adoConfig.DisplayTable'
          :display-bar='adoConfig.DisplayBar'
          :display-line='adoConfig.DisplayLine'
          :display-pie='adoConfig.DisplayPie'
          :display-default='displayDefault'
          :display-percentage='adoConfig.DisplayPercentage'
          :total-count='pgCount'
          :page-size='pgSize'
          :page-index='pgIndex'
          :on-bind-data='
          adoConfig.DisplayPager
            ? (pageindex) => createReport(pageindex, true)
            : null
        '
        >
        </znl-echarts>
      </pane>
      <!-- <pane title='购买记录：' v-show='adoConfig.Price !== 0'>
        <znl-gridmodule
          :on-init='onInit'
          :columns='columns'
          :item-source='datas'
          :loading='loading'
          :total-count='totalCount'
          :page-size='pageSize'
          :page-index='pageIndex'
          :on-page-changed='onBindData'
          :is-init='false'
          height='auto'
        >
        </znl-gridmodule>
      </pane> -->
      <znl-dialog
        title='付费确认'
        :visible.sync='visible'
        :append-to-body='true'
        class='p-znlado-price'
        width='500px'>
        <div>
          此服务为收费服务，年费用户不会扣款，直接点击确认；非年费用户请认真查看以下内容，一经确认即会扣费。由于虚拟产品特殊性，任何情况下不允许退费。
          <div>
            服务收费： <span class='pricenum'>￥{{ adoConfig.Price }}</span>
          </div>
        </div>

        <div slot='footer'>
          <znl-button
            :width='80'
            :height='30'
            @click='visible = false'
            :style="{ marginRight: '10px' }">关闭
          </znl-button>
          <znl-button
            :width='80'
            :height='30'
            @click='confirmCallBack'
            style-type='main'>确认
          </znl-button>
        </div>
      </znl-dialog>
    </page-layout>
  </div>

</template>

<script>
import Pane from './adopane.vue';
import ZnlEcharts from './znlEcharts.vue';
import PageLayout from './PageLayout.vue';
import { adoColumns } from './scripts/columnConfig';
import { CONFIG as PROCONFIG } from '../assets/scripts/config';
import { httpGet, httpPost } from '~~assets/scripts/http';
import { $succMess, $erroMess } from '~~utils/utils';

// 新模块
import ModulesView from './modules/index.vue';
// import modules from '~~components/modules/modules.js';
const CONFIG = {
  purchaselog: 'report/purchase/log'
};

export default {
  mixins: [],
  components: {
    Pane,
    ZnlEcharts,
    PageLayout,
    ModulesView
  },
  data () {
    return {
      loading: false,
      pageloading: false,
      columns: adoColumns,
      datas: [],
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      pgIndex: 1,
      pgSize: 50,
      pgCount: 0,
      reportParameter: {},
      proconfig: PROCONFIG.RES_URL,
      fileList: [],
      visible: false,
      fileSucessId: '',
      DownloadFileName: '',
      tipShow: false,
      chartsOptions: {
        Datas: [],
        DownloadFileName: '',
        Title: ''
      }
    };
  },

  props: {
    type: {
      type: String,
      default () {
        return 'old';
      }
    },
    token: String,
    id: {
      type: String,
      default: ''
    },
    adoConfig: {
      type: Object,
      default () {
        return {};
      }
    },
    displayDefault: {
      type: Number,
      default: 0
    },
    portname: {
      type: String,
      default: ''
    }
  },
  watch: {
    adoConfig: {
      deep: true,
      handler: async function(newvalue) {
        if (this.type === 'new') return false;

        this.defaultHandler(newvalue);
        // 无参数且免费时直接生成
        if (
          newvalue.Params &&
          newvalue.Params.length === 0 &&
          newvalue.Price === 0
        ) {
          await this.createReport(1);
          await this.$refs.znlEcharts.onInit();
        } else {
          // 非免费生成时清空数据
          this.chartsOptions.Datas = [];
          this.chartsOptions.DownloadFileName = '';
          this.chartsOptions.Title = '';
          await this.$refs.znlEcharts.onInit();
        }
      }
    },
    id () {
      // if (this.type === 'new') return false;
      // this.onInit();
    }
  },
  computed: {
    headers () {
      const auth = this.token;
      if (auth) {
        return {
          Authorization: 'JWT ' + auth
        };
      }
      return {};
    },
    uploadStyle () {
      const style = { left: '0px' };
      const showsNum = [
        this.adoConfig.DisplayTable,
        this.adoConfig.DisplayLine,
        this.adoConfig.DisplayBar,
        this.adoConfig.DisplayPie
      ].filter(item => {
        return item;
      }).length;
      switch (showsNum) {
        case 0:
          style.left = '60px';
          break;
        case 1:
          style.left = '90px';
          break;
        case 2:
          style.left = '120px';
          break;
        case 3:
          style.left = '150px';
          break;
        default:
          break;
      }
      return style;
    }
  },
  methods: {
    defaultHandler (config) {
      if (config.Params && config.Params.length > 0) {
        config.Params.map(item => {
          this.reportParameter[item.Name] = this.eval(
            item.Type === 2
              ? new Date(item.DefaultExpression)
              : item.DefaultExpression || ''
          );
        });
      }
    },
    /**
     * 清空参数
     */
    refreshPrarms () {
      this.reportParameter = {};
      this.pgIndex = 1;
      this.pgSize = 20;
      this.pgCount = 0;
      this.chartsOptions.Datas = [];
      this.chartsOptions.DownloadFileName = '';
      this.chartsOptions.Title = '';
      this.fileSucessId = '';
      this.DownloadFileName = '';
    },
    eval (value) {
      return window.eval(value);
    },
    async onInit () {
      return this.onBindData();
    },
    onBindData (pageIndex = 1) {
      this.loading = true;
      const reqData = {
        PageIndex: pageIndex,
        PageSize: this.pageSize,
        configID: this.id
      };
      return httpGet(this.token, CONFIG.purchaselog, reqData)
        .then(response => {
          this.changeHandler([
            {
              key: 'loading',
              value: false
            }
          ]);
          if (response) {
            const data = response || {};
            const items = data.ResultList || [];
            this.changeHandler([
              {
                key: 'datas',
                value: items
              },
              {
                key: 'pageIndex',
                value: data.PageIndex ? data.PageIndex : 1
              },
              {
                key: 'totalCount',
                value: data.TotalCount
              }
            ]);
          }
        })
        .then(() => {
          setTimeout(() => {
            this.changeHandler([
              {
                key: 'loading',
                value: false
              }
            ]);
          }, 200);
        });
    },
    changeHandler (items) {
      items.map(item => {
        this[item.key] = item.value;
      });
    },
    // 判断是否可以直接生成
    async ispurchased () {
      const that = this;
      const pres = {
        ListParamsFile: this.fileSucessId,
        SingleParams: {
          ...that.reportParameter
        }
      };
      return httpPost(this.token, `report/ispurchased/${that.id}`, pres)
        .then(data => {
          that.pageloading = false;
          if (data.Code === 0 && data.Data) {
            // 免费 || 已经付费
            this.createReport(1);
          } else if (data.Code === 11002) {
            // 需要收费
            // that.visible = true;
            this.createReport(1);
          } else if (data.Code === 11010) {
            // 需要收费
            // that.visible = true;
            // $erroMess('余额不足');
            this.$msgbox({
              title: '联系我们',
              message:  `<div style="line-height:28px;">
                <div class="items-center" >开通数据工具,请联系销售</div>
                <div class="items-center" style="margin-top:8px;">
                  销售咨询:
                  <span class="ml-r8">400-699-2899(转1)</span>
                </div>
                <div class="items-center" style="margin-top:8px;">
                  销售QQ: 
                  <a class="jump" href="https://wpa.qq.com/msgrd?v=3&amp;uin=800106568&amp;site=qq&amp;menu=yes" target="_blank">
                    <div class="QQ"></div>
                    <span>800106568</span>
                  </a>
                </div>
              </div>`,
              dangerouslyUseHTMLString: true,
              showConfirmButton: false,
              customClass: 'customBox'
            }).catch(()=>{}).finally(()=>{
              elMessageBox.style = null
              this.$nextTick(()=>{
                console.log(elMessageBox);
              })
            })    
          } else {
            // 生成失败
            $erroMess(data.Message);
          }
        })
        .catch(() => {
          that.pageloading = false;
        });
    },
    // 生成报告
    async createReport (pageIndex = 1, showLoading) {
      const that = this;
      if (!showLoading) {
        that.pageloading = true;
      }
      const pres = {
        ListParamsFile: this.fileSucessId,
        SingleParams: {
          ...that.reportParameter
        }
      };
      if (this.adoConfig.DisplayPager) {
        pres.PageIndex = pageIndex;
        pres.PageSize = this.pgSize;
      }
      return httpPost(this.token, `report/exec/${that.id}`, pres, {
        baseURL: 'res'
      })
        .then(data => {
          that.pageloading = false;
          if (data) {
            console.log(data, 111);
            // 免费生成
            that.visible = false;
            that.chartsOptions = data;
            that.pgIndex = data.PageIndex;
            that.pgSize = data.PageSize;
            that.pgCount = data.TotalRecord;
            that.DownloadFileName = data.DownloadFileName;
            that.$nextTick(() => {
              const childColumn = that.$refs.znlEcharts.columns[0];
              if (childColumn && childColumn.binding === '无数据') {
                that.$refs.znlEcharts.onInit();
              }
              that.$refs.znlEcharts.getData();
            });
          }
        })
        .catch(() => {
          that.pageloading = false;
        });
    },
    // 确认付费
    confirmCallBack () {
      this.createReport(1);
    },

    onSuccess (response) {
      if (response.Code === 200) {
        $succMess('上传成功');
        this.fileSucessId = response.Result;
      } else {
        $erroMess('上传失败');
      }
    },
    inputChangeHandler (item) {
      this.reportParameter[item.Name] = this.reportParameter[
        item.Name
        ].toUpperCase();
    }
  }
};
</script>

<style lang='scss'>
$header-height: 100px;
.p-ZnlAdo {
  box-sizing: border-box;
  position: relative;
  padding: 6px;

  .p-ZnlAdo-header {
    height: $header-height;
    line-height: $header-height;

    .p-ZnlAdo-title {
      font-size: 26px;
      color: $--fontcolor-dark-3;
      font-weight: 600;
    }

    .p-ZnlAdo-explain {
      line-height: 30px;
      margin-left: 30px;

      .title {
        font-size: $--font-size-medium;
      }
    }
  }

  .p-ZnlAdo-report {
    line-height: 30px;

    .uploadbtn {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
    }

    .znl-component-input {
      margin-right: 5px;
    }

    .upload-data {
      display: inline-block;
    }

    .znl-button {
      .button {
        font-size: $--font-size-base;
        position: relative;
      }

      &.znl-btn-text {
        background-color: transparent;
      }
    }

    .p-ZnlAdo-report-input {
      padding: 3px 0;
      display: inline-block;
      width: 200px;
      line-height: 24px;
      margin-right: 5px;

      .p-ZnlAdo-report-input-title {
        font-size: 12px;
        padding-right: 10px;
        font-weight: bold;
        display: inline-block;
        width: 100%;
      }
    }
  }

  .el-tabs__header {
    position: absolute;
    top: 0;
    left: 60px;

    .iconfont {
      font-size: 20px;
    }
  }

  .znl-ZnlAdo-upload-a {
    font-size: 12px;
    color: #2288cc;
    text-decoration: underline;
    cursor: pointer;
  }

  .znl-ZnlAdo-upload {
    position: absolute;
    top: 0px;
    left: 90px;
  }

  .p-ZnlAdo-tip {
    margin-top: 5px;
    font-size: 12px;
    border: 1px solid #e6e6e6;
    left: 0px;
    top: 30px;
    z-index: 10;
    background-color: #fff;
    border-radius: 5px;
    line-height: 22px;
    padding: 0 5px;
    color: $--fontcolor-dark-3;
  }

  .p-ZnlAdo-report-title {
    line-height: 40px;
    height: 40px;
  }
}

.p-znlado-price {
  .znl-dialog__body {
    line-height: 30px;
    font-weight: bold;
  }

  .pricenum {
    color: #ee7700;
    font-weight: bold;
  }
}

.p-znlNew {
  box-sizing: border-box;
  position: relative;
  padding: 6px;
  height: 100%;
  min-width: 1300px;
}
.customBox {
  width: 260px;
  border-radius: 8px;
  .el-message-box__title {
    font-weight: bold;
    font-size: 14px;
  }
  .el-message-box__message {
    padding-left: 16px;
  }
  .jump {
    text-decoration: none; /* 去除默认的下划线 */
    outline: none;	/* 去除旧版浏览器的点击后的外虚线框 */
    color: #606266;	/* 去除默认的颜色和点击后变化的颜色 */ 
    display: flex;
    align-items: center;
  }
  .QQ {
    width: 16px;
    height: 16px;
    background-image: url("data:image/svg+xml;base64,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");
    margin-left: 8px;
    margin-right: 2px;
  }
  .items-center {
    display: flex;
    align-items: center;
  }
  .ml-r8 {
    margin-left: 8px;
  }
}
</style>

